import React from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from '@material-ui/core';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import * as S from './styles';

function TableAderenciaDiesel({ d1, mes, ano, meta, data }) {
  return (
    <S.WrapperTable>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell rowSpan="2">
                {t('s.indicadoroperacao.farol')}
              </TableCell>
              <TableCell rowSpan="2">
                {t('s.menu.configuracao.posto')}
              </TableCell>
              <TableCell colSpan="3">
                {`${t('s.indicadoroperacao.variacaod1')} (${d1})`}
              </TableCell>
              <TableCell colSpan="3">{`${t(
                's.indicadoroperacao.variacaomes'
              )} (${mes})`}</TableCell>
              <TableCell colSpan="3">{`${t(
                's.indicadoroperacao.variacaoano'
              )} (${ano})`}</TableCell>
            </TableRow>
            <TableRow>
              {Array(3)
                .fill([
                  t('s.indicadoroperacao.volabast'),
                  t('s.indicadoroperacao.valps'),
                  t('s.indicadoroperacao.percps'),
                ])
                .flat()
                .map((header, i) => (
                  <TableCell key={i}>{header}</TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow
                key={row.postodesc}
                className={!row.idposto ? 'row-gray' : ''}
              >
                <TableCell className="FarolCell">
                  {Math.abs(Math.round(row.percentualmes * 100)) <= 20 ? (
                    <SentimentVerySatisfiedIcon
                      style={{ color: '#57d9a3', fontSize: 24 }}
                    />
                  ) : (
                    <SentimentVeryDissatisfiedIcon
                      style={{ color: '#ff7452', fontSize: 24 }}
                    />
                  )}
                </TableCell>
                <TableCell className="PostoCell">{row.postodesc}</TableCell>
                <TableCell>{number(row.totvolabastambd1, 2)}</TableCell>
                <TableCell>{number(row.perdasobrad1, 2)}</TableCell>
                <TableCell
                  className={
                    Math.abs(Math.round(row.percentuald1 * 100)) > meta * 100
                      ? 'cell-danger'
                      : 'cell-success'
                  }
                >
                  {number(row.percentuald1, 2)}
                </TableCell>
                <TableCell>{number(row.totvolabastambmes, 2)}</TableCell>
                <TableCell>{number(row.perdasobrames, 2)}</TableCell>
                <TableCell
                  className={
                    Math.abs(Math.round(row.percentualmes * 100)) > meta * 100
                      ? 'cell-danger'
                      : 'cell-success'
                  }
                >
                  {number(row.percentualmes, 2)}
                </TableCell>
                <TableCell>{number(row.totvolabastambano, 2)}</TableCell>
                <TableCell>{number(row.perdasobraano, 2)}</TableCell>
                <TableCell
                  className={
                    Math.abs(Math.round(row.percentualano * 100)) > meta * 100
                      ? 'cell-danger'
                      : 'cell-success'
                  }
                >
                  {number(row.percentualano, 2)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTable>
  );
}

TableAderenciaDiesel.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  meta: PropTypes.number,
  d1: PropTypes.string.isRequired,
  mes: PropTypes.string.isRequired,
  ano: PropTypes.string.isRequired,
};

TableAderenciaDiesel.defaultProps = {
  data: {},
  meta: 0.2,
};

export default TableAderenciaDiesel;
